import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  currentYear: number;

  constructor() {
    const today = new Date();
    this.currentYear = today.getFullYear();
  }

}
